export const normalizeServerError = async serverError => {
  if (serverError instanceof Blob) {
    const reader = new FileReader();
    reader.readAsText(serverError);
    const error = await new Promise(resolve => {
      reader.onload = () => resolve(reader.result);
    });
    const errorMessage = JSON.parse(error).message;
    return [errorMessage];
  }
  const { errors } = serverError;
  const result = [];
  result.push(serverError.message);
  // `errors` is a LIST of field errors on the validation paths, but several
  // endpoints answer with a machine-readable OBJECT instead — e.g. the routes
  // dataset returns `{"currentRowVersion": 1}` on a snapshot conflict and
  // `{"activationId": "..."}` on a 423. Calling forEach on those threw a
  // TypeError out of the response interceptor, so the caller received that
  // TypeError INSTEAD of `{messages, errors, status}` and could not read the
  // status at all. Only a list contributes messages; an object carries no
  // human-readable text of its own (the `message` above already states it) and
  // is passed through untouched for the caller to read.
  if (Array.isArray(errors)) {
    errors.forEach(err => {
      if (err instanceof Object) {
        result.push(`${err.fieldName}: ${err.message}`);
      }
    });
  }
  return result;
};
